import { c as _c } from "react/compiler-runtime";
import { IcoArrowUpRight16 } from '@onefootprint/icons';
import Button from '../button';
import type { CtaProps } from './cta.types';
type CtaButtonProps = {
  cta: CtaProps;
  variant?: 'secondary';
  isLoading?: boolean;
};
export const CtaButton = t0 => {
  const $ = _c(19);
  const {
    cta,
    variant,
    isLoading
  } = t0;
  if (cta.type === "link") {
    const t1 = cta.loading ?? isLoading;
    const t2 = cta.target === "_blank" ? IcoArrowUpRight16 : undefined;
    let t3;
    if ($[0] !== cta.actionName || $[1] !== cta.disabled || $[2] !== cta.href || $[3] !== cta.onClick || $[4] !== cta.target || $[5] !== cta.text || $[6] !== t1 || $[7] !== t2 || $[8] !== variant) {
      t3 = <Button href={cta.href} target={cta.target} onClick={cta.onClick} loading={t1} disabled={cta.disabled} data-dd-action-name={cta.actionName} variant={variant} fullWidth={true} size="large" suffixIcon={t2}>{cta.text}</Button>;
      $[0] = cta.actionName;
      $[1] = cta.disabled;
      $[2] = cta.href;
      $[3] = cta.onClick;
      $[4] = cta.target;
      $[5] = cta.text;
      $[6] = t1;
      $[7] = t2;
      $[8] = variant;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  const t1 = cta.loading ?? isLoading;
  const t2 = cta.type === "submit" ? cta.form : undefined;
  let t3;
  if ($[10] !== cta.actionName || $[11] !== cta.disabled || $[12] !== cta.onClick || $[13] !== cta.text || $[14] !== cta.type || $[15] !== t1 || $[16] !== t2 || $[17] !== variant) {
    t3 = <Button type={cta.type} onClick={cta.onClick} loading={t1} disabled={cta.disabled} data-dd-action-name={cta.actionName} variant={variant} fullWidth={true} size="large" form={t2}>{cta.text}</Button>;
    $[10] = cta.actionName;
    $[11] = cta.disabled;
    $[12] = cta.onClick;
    $[13] = cta.text;
    $[14] = cta.type;
    $[15] = t1;
    $[16] = t2;
    $[17] = variant;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  return t3;
};